module.exports = __webpack_public_path__ + "static/media/sector_infographic.1938b429.png";